import useFlowCreateRouteConfig from "../../../routes/configs/flows/FlowCreateRouteConfig";
import useFlowEditRouteConfig from "../../../routes/configs/flows/FlowEditRouteConfig";
import DataTable, { useDataTable } from "../main/DataTable";
import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import useTimestampColumnConfig from "../main/config/column/default/TimestampColumnConfig";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useDuplicateRowActionConfig from "../main/config/rowAction/default/DuplicateRowActionConfig";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";

function FlowsDataTable() {
  //Create the datatable config
  const config = new DataTableConfig("flows");

  //Set the datatable fetch info
  config.setFetchRequest("flows");

  //Set the datatable order by
  config.setOrderBy("name");
  config.setOrderDirection("asc");

  //set the datatable columns
  config.setColumns([
    useBasicColumnConfig("name").setLockActive(true),
    useTimestampColumnConfig("created_at"),
    useTimestampColumnConfig("updated_at"),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig("flow", useFlowCreateRouteConfig()),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig("flow", useFlowEditRouteConfig()),
    useDuplicateRowActionConfig("flow"),
    useDeleteRowActionConfig("flow"),
  ]);

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default FlowsDataTable;
